<mat-toolbar color="accent">Enrol from File</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <h3 class="!m-0 !font-bold">Enrolment Estimates</h3>
      @if (loading()) {
        <div class="flex flex-col items-center justify-center gap-4">
          <mat-spinner [diameter]="32" />
          <div class="text-xs opacity-50">
            Loading entries from the file, please wait...
          </div>
        </div>
      } @else {
        @if (enrolment$ | async; as enrolment) {
          <pr-campaign-run-enrolment-estimates
            [enrolment]="enrolment$ | async"
          />
        } @else {
          <pr-information-box theme="warn">
            @if (errorMessage$ | async; as errorMessage) {
              <p class="!m-0 font-bold">Error loading file</p>
              <p class="!m-0">{{ errorMessage }}</p>
            } @else {
              Something went wrong while processing the report. Please try
              again.
            }
          </pr-information-box>
        }
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="isDisabled$ | async"
      (click)="submit()"
    >
      Preview Entries
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
